import React from "react";
import { Typography, Link, Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { pushCustomEvent } from "../../../utils/customEventHelper";
import { useRouter } from "../../common/Router";

const MyWarhammerPreLoginCustomisation: React.FC = () => {
  const { setLoc } = useRouter();
  const { t } = useTranslation();

  return (
    <Box mb={2}>
      <Typography
        data-testid="linkingPreface"
        variant="body2"
        align="center"
        paragraph
      >
        {t("login.linkingPreface")}
      </Typography>

      <Typography
        data-testid="registrationPrompt"
        variant="body2"
        align="center"
        paragraph
      >
        <Trans
          i18nKey="login.registrationPrompt"
          components={{
            Link: (
              <Link
                data-testid="registrationLink"
                href="#signup"
                underline="always"
                onClick={(): void => {
                  pushCustomEvent("registrationLink");
                  setLoc("signup");
                  window.location.hash = "#signup";
                  window.scrollTo(0, 0);
                }}
              />
            ),
          }}
        />
      </Typography>
      <Typography
        data-testid="loginPreface"
        variant="body2"
        align="center"
        style={{ fontWeight: 700 }}
        paragraph
      >
        {t("login.loginPreface")}
      </Typography>
    </Box>
  );
};

export default MyWarhammerPreLoginCustomisation;
